import GrayRightIcon from '@assets/images/app/icon-arr-gray-right-12.png';
import { DeepLinkActions, useDeeplink } from '@hooks/deeplink';
import React from 'react';
import { MainFeedCellProps } from '.';
import ProductItem from '../common/ProductItem';
import { useAuthentication } from '@hooks/authentication';
import { useAppUserSessionStore } from '@stores/appUserSessionStore';
import { getDistanceBetweenGpsCoordinates } from '@utils/common';

export const ProductGridCell: React.FC<MainFeedCellProps> = (props) => {
  const { myMembership } = useAuthentication();
  const { linkTo } = useDeeplink();
  const data = props.data;
  const sessionStore = useAppUserSessionStore();
  const currentLocation = sessionStore.currentLocation;

  return (
    <div id="class-grid-cell">
      <div
        style={{
          width: '100%',
          backgroundColor: 'white',
          padding: '0 16px',
        }}>
        <div
          style={{
            display: 'flex',
            marginBottom: '20px',
            backgroundColor: 'white',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <div
            id="class-grid-cell-title"
            style={{
              fontSize: '19px',
              fontWeight: 'bold',
              color: '#242424',
            }}>
            {props.title}
          </div>
          <button
            className="link-button"
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
            onClick={() => {
              linkTo(
                { action: DeepLinkActions.GO_TO_COLLECTION, payload: { collectionId: props.collectionId } },
                { source: `product-grid-cell-show-all-${props.index}` },
              );
            }}>
            <div
              style={{
                fontSize: '14px',
                color: '#808387',
                lineHeight: '17px',
              }}>
              전체보기
            </div>
            <img src={GrayRightIcon} style={{ width: '12px', height: '12px' }} alt="" />
          </button>
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            rowGap: '24px',
          }}>
          {data.map((item: any, index: number) => {
            const distance =
              currentLocation?.latitude &&
              currentLocation?.longitude &&
              item.gpsLocation?.coordinates &&
              getDistanceBetweenGpsCoordinates(
                item.gpsLocation?.coordinates[1],
                item.gpsLocation?.coordinates[0],
                currentLocation?.latitude,
                currentLocation?.longitude,
              );
            return (
              <div
                key={`product-item-${index}`}
                style={{ flex: '0 0 auto', width: 'calc(50% - 6px)', cursor: 'pointer' }}>
                <ProductItem
                  key={`product-item-${index}`}
                  distance={distance}
                  item={item}
                  membership={myMembership}
                  onClick={() => {
                    linkTo(
                      {
                        action: DeepLinkActions.GO_TO_PRODUCT,
                        payload: { productId: item._id },
                      },
                      { source: `product-grid-cell-${props.index}`, index: index },
                    );
                  }}></ProductItem>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductGridCell;
